module.exports = __webpack_public_path__ + "static/img/pic-banner@2x.2b295c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/pic-banner@2x.png
// module id = 828
// module chunks = 0